import { DEFAULTAVATAR } from 'Constants';
import { Context } from 'Context/Context';
import { Check, ChevronRight } from 'lucide-react';
import ProfesssionalDetailsPopUp from 'Modals/ProfesssionalDetailsPopUp';
import React, { useContext, useEffect, useState } from 'react'
import { getCaseType } from 'Utils';
import useIsMobile from 'Hooks/useIsMobile';

function PreApproveAttorneysTable({
    profList,
    caseDetails,
    approveProfessional,
    title
}) {
    const [showModal, setShowModal] = useState(false);
    const [singleUser, setSingleUser] = useState(null);
    const {makeApiCallFunc} = useContext(Context);
    const isMobile = useIsMobile();
    let initialProfData = {
         "First name" : "firstName",
        "Last name" : "lastName",
        "Email" : "email",
        "Designation" : "legalType",
        "Firm Name" : "company",
        "Phone number" : "phoneNumber",
        "Experience" : "experience",
        "Law Firm URL" : "lawFirmLink",
        "LinkedIn" : "linkedin",
        "Case Preference": "casePref",
        "State Preference" : "statePref"
    }
    useEffect(() => {
        if(singleUser?.isUserFunder)
        {
            initialProfData = {
                 "First name" : "firstName",
            "Last name" : "lastName",
            "Email" : "email",
            "Designation" : "legalType",
            "Firm Name" : "company",
            "Phone number" : "phoneNumber",
            "Experience" : "experience",
            "URL" : "lawFirmLink",
            "LinkedIn" : "linkedin",
            "Case Preference": "casePref",
            "State Preference" : "statePref"
        }
        console.log("Funder profile data", singleUser);
    }
    },[])

    const [profData, setProfData] = useState(initialProfData);

    // Case/state preference shown as two separate pill tags (matching the
    // design) instead of one combined "casePref · statePref" line.
    const getPreferenceTags = (ele) => {
        const casePrefLabel = ele?.casePref?.filter((i) => i === caseDetails?.caseType).length
            ? getCaseType(ele?.casePref?.filter((i) => i === caseDetails?.caseType)?.[0])
            : "All case types";
        const statePrefLabel = ele?.statePref?.filter((i) => i === caseDetails?.caseState).length
            ? ele?.statePref?.filter((i) => i === caseDetails?.caseState)
            : "All states";
        return [casePrefLabel, statePrefLabel];
    }

  return (
    <>
    {
        showModal &&
        <>
        <ProfesssionalDetailsPopUp uploadNew={showModal} onClose={() => setShowModal(false)} singleUser={singleUser} profData= {profData}
            content = {
            <div
            className='w-full text-center rounded-lg py-3 font-semibold bg-tan text-white cursor-pointer hover:bg-tanDark transition-colors'
            onClick={() => {setShowModal(false);approveProfessional(singleUser._id);}}
            >Approve {singleUser?.firstName} {singleUser?.lastName}
            </div>}
            />

        </>
    }
    {profList.length !== 0 &&

    <div className='flex items-center flex-col w-full font-plexsans'>
        {title}
        <div className={'flex w-full flex-col gap-2.5 ' + (isMobile ? '' : 'max-h-[320px] overflow-y-auto')}>
            {profList?.map((ele, index) => {
                const [casePrefTag, statePrefTag] = getPreferenceTags(ele);
                if (isMobile) {
                  // Mobile: one line of who they are + a compact Approve; details on tap
                  return (
                    <div
                    key={index}
                    role="button"
                    tabIndex={0}
                    onClick={() => { setSingleUser(ele); setShowModal(true); }}
                    className='flex items-center gap-3 border border-[rgba(20,33,61,.12)] rounded-[10px] p-3 bg-white'
                    >
                        <img className='w-10 h-10 rounded-full object-cover flex-none bg-[rgba(20,33,61,.05)]' src={ele?.profilePic ? ele?.profilePic : DEFAULTAVATAR} alt="" />
                        <div className='min-w-0 flex-1'>
                            <div className='text-[14px] font-semibold text-navy truncate'>{ele?.firstName} {ele?.lastName}</div>
                            <div className='text-[12px] text-[rgba(20,33,61,.5)] truncate'>{ele?.isUserFunder ? 'Litigation funder' : (ele?.company || ele?.legalType || 'Attorney')}</div>
                        </div>
                        <button
                        type="button"
                        className='flex items-center gap-1 rounded-lg bg-tan text-white px-3 py-2 text-[13px] font-semibold flex-none'
                        onClick={(e) => { e.stopPropagation(); approveProfessional(ele._id); }}
                        >
                            <Check size={14}/> Approve
                        </button>
                    </div>
                  );
                }
                return (
                <div
                key={index}
                role="button"
                tabIndex={0}
                onClick={() => {
                    setSingleUser(ele);
                    setShowModal(true);
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        setSingleUser(ele);
                        setShowModal(true);
                    }
                }}
                className='group flex items-center justify-between gap-3 border border-[rgba(20,33,61,.12)] rounded-[10px] p-3.5 bg-ivory cursor-pointer hover:border-[rgba(154,59,46,.35)] hover:shadow-[0_2px_10px_rgba(20,33,61,.08)] transition-all'
                >
                    <div className='flex items-center gap-3 min-w-0'>
                        <img
                        className='w-11 h-11 rounded-full object-cover flex-none bg-[rgba(20,33,61,.05)]'
                        src={ele?.profilePic ? ele?.profilePic : DEFAULTAVATAR}
                        alt=""
                        />
                        <div className='min-w-0'>
                            <div className='text-[14px] font-semibold text-navy truncate'>
                                {ele?.firstName} {ele?.lastName}
                            </div>
                            <div className='text-[12px] text-[rgba(20,33,61,.5)] truncate capitalize'>
                                {ele?.legalType}{ele?.company ? ` · ${ele.company}` : ""}
                            </div>
                            <div className='flex items-center gap-1.5 mt-1.5 flex-wrap'>
                                <span className='text-[10.5px] font-medium text-tan bg-[rgba(138,98,49,.08)] rounded-full px-2 py-[3px] whitespace-nowrap'>{casePrefTag}</span>
                                <span className='text-[10.5px] font-medium text-tan bg-[rgba(138,98,49,.08)] rounded-full px-2 py-[3px] whitespace-nowrap'>{statePrefTag}</span>
                            </div>
                        </div>
                    </div>
                    <div className='flex items-center gap-2 flex-none'>
                        <button
                        type="button"
                        className='flex items-center gap-1.5 rounded-lg bg-tan text-white px-3.5 py-2 text-[13px] font-semibold hover:bg-tanDark transition-colors whitespace-nowrap'
                        onClick={(e) => {
                            e.stopPropagation();
                            approveProfessional(ele._id);
                        }}
                        >
                            <Check size={14}/>
                            Approve
                        </button>
                        <ChevronRight size={16} className='text-[rgba(20,33,61,.3)] group-hover:text-[rgba(154,59,46,.6)] transition-colors flex-none' />
                    </div>
                </div>
                );
            })}
        </div>
     </div>
    }
    </>
  )
}

export default PreApproveAttorneysTable
